import { useState, type FormEvent } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Search, MapPin } from "lucide-react";
import { categories, locations } from "@/lib/data";

export function SearchBar({ size = "lg" }: { size?: "lg" | "md" }) {
  const [q, setQ] = useState("");
  const [city, setCity] = useState("");
  const navigate = useNavigate();

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    const cat = categories.find(
      (c) =>
        c.name.toLowerCase().includes(q.toLowerCase()) ||
        c.slug === q.toLowerCase(),
    );
    const loc = locations.find(
      (l) =>
        l.name.toLowerCase() === city.toLowerCase() ||
        l.slug === city.toLowerCase(),
    );
    if (loc && cat) {
      navigate({ to: "/location/$loc/$cat", params: { loc: loc.slug, cat: cat.slug } });
    } else if (cat) {
      navigate({ to: "/category/$slug", params: { slug: cat.slug } });
    } else if (loc) {
      navigate({ to: "/location/$slug", params: { slug: loc.slug } });
    } else {
      navigate({ to: "/category" });
    }
  };

  return (
    <form
      onSubmit={onSubmit}
      className={`flex w-full flex-col gap-2 rounded-2xl border border-border bg-card p-2 shadow-card-lg sm:flex-row ${
        size === "lg" ? "sm:p-2" : ""
      }`}
    >
      <label className="flex flex-1 items-center gap-2 rounded-xl px-3 sm:py-2">
        <Search className="h-4 w-4 text-muted-foreground" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Restaurants, coffee, plumbers…"
          className="w-full bg-transparent py-2 text-sm outline-none placeholder:text-muted-foreground"
          list="cat-suggest"
        />
        <datalist id="cat-suggest">
          {categories.map((c) => (
            <option key={c.slug} value={c.name} />
          ))}
        </datalist>
      </label>
      <div className="hidden w-px self-stretch bg-border sm:block" />
      <label className="flex flex-1 items-center gap-2 rounded-xl px-3 sm:py-2">
        <MapPin className="h-4 w-4 text-muted-foreground" />
        <input
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder="Austin, Portland, Brooklyn…"
          className="w-full bg-transparent py-2 text-sm outline-none placeholder:text-muted-foreground"
          list="loc-suggest"
        />
        <datalist id="loc-suggest">
          {locations.map((l) => (
            <option key={l.slug} value={l.name} />
          ))}
        </datalist>
      </label>
      <button
        type="submit"
        className="rounded-xl bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:scale-[1.02]"
      >
        Search
      </button>
    </form>
  );
}
